// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface FilteredTableStyle {
    container?: InjectableCss;
    lastCell?: InjectableCss;
    orderTotalCells?: InjectableCss;
    noResultsContainer?: InjectableCss;
}

export const filteredTableStyle: FilteredTableStyle = {
    container: {
        css: css`
            margin-top: 20px;
            overflow-x: auto;
        `,
    },

    lastCell: {
        css: css`
            justify-content: flex-end;
            text-align: right;

            button {
                justify-content: flex-end;
            }
        `,
    },

    orderTotalCells: {
        css: css`
            text-align: left;
        `,
    },

    noResultsContainer: {
        css: css`
            padding: 20px 0;
        `,
    },
};
